/**
 * Session-cookie fetch wrapper for the v2 tenant-scoped brand routes
 * (/api/brand/:slug/*). Unlike lib/api.ts (Heady identity headers), these
 * endpoints authenticate via the storesync_session cookie set at magic-link
 * consume, so every call sends credentials.
 */

async function call(method: string, url: string, body?: unknown, isForm = false): Promise<any> {
  const init: RequestInit = { method, credentials: "include" };
  if (body !== undefined) {
    if (isForm) {
      init.body = body as FormData;
    } else {
      init.headers = { "Content-Type": "application/json" };
      init.body = JSON.stringify(body);
    }
  }
  const res = await fetch(url, init);
  const ct = res.headers.get("content-type") || "";
  if (!res.ok) {
    let msg = res.statusText;
    try {
      if (ct.includes("json")) {
        const j = await res.json();
        msg = j.message || j.error || msg;
      } else msg = await res.text();
    } catch {}
    throw new Error(`${res.status}: ${msg}`);
  }
  return ct.includes("json") ? res.json() : res.text();
}

export const brandApi = {
  get: (url: string) => call("GET", url),
  post: (url: string, body?: unknown) => call("POST", url, body),
  postForm: (url: string, form: FormData) => call("POST", url, form, true),
  patch: (url: string, body?: unknown) => call("PATCH", url, body),
  del: (url: string) => call("DELETE", url),
};
